import {
  apiUrl,
  getList,
  getSingleRecord,
  getStatsData,
  exportData,
  putAction,
} from './apiUtils';
import type { ApiListParamsWithUnderscores, ApiExportParams } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';
import type {
  AccountDetailListItem,
  AccountDetailItem,
  AccountDetailKeyRequestListItem,
} from '../types/api/accountDetails';

const baseUrl = apiUrl + '/accounts/';

export function getAccountDetails(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<AccountDetailListItem>> {
  return getList<AccountDetailListItem>(`${baseUrl}search`, params);
}

export function getAccountDetailById(id: string): Promise<AccountDetailItem> {
  return getSingleRecord<AccountDetailItem>(baseUrl, id);
}

export function loadAccountDetailKeyRequests(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<AccountDetailKeyRequestListItem>> {
  return getList<AccountDetailKeyRequestListItem>(`${baseUrl}keyRequests`, params);
}

export function loadAccountDetailKeyRequestsForAccount(
  id: string,
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<AccountDetailKeyRequestListItem>> {
  return getList<AccountDetailKeyRequestListItem>(`${baseUrl}${id}/keyRequests`, params);
}

export function getStats(id: string) {
  return getStatsData(baseUrl, id);
}

export function exportAccountData(params: ApiExportParams): Promise<void> {
  return exportData(`${apiUrl}/export/accounts/search`, 'login', params);
}

export function exportAccountDetailKeyRequestsForAccount(
  id: string,
  params: ApiExportParams
): Promise<void> {
  return exportData(`${apiUrl}/export/accounts/${id}/keyRequests`, 'game', params);
}

export function exportAccountDetailKeyRequests(params: ApiExportParams): Promise<void> {
  return exportData(`${apiUrl}/export/accounts/keyRequests`, 'login', params);
}

export function updateAccountDetail(id: string, record: unknown): Promise<string> {
  return putAction<string>(`${baseUrl}${id}`, record);
}
